const formatPrice = (price) => {
	return !isNaN(price) ? parseFloat(price).toFixed(2).replace('.', ',') : price;
};

export default formatPrice;
